// extracted by mini-css-extract-plugin
export default {"removeSection":"removeSection__nlF7Wr","optionsPopup":"optionsPopup__hTOkUD","optionLabel":"optionLabel__fvMEJ9"};